module.exports = __webpack_public_path__ + "prod/1.42.2/img/android-icon.b7abd13c.svg";